import React from 'react';
import { Button } from '@material-ui/core';
import { getState } from '../../../../../../redux/store';
import { ReducerKeys } from '../../../../../../redux/reducers';
import { IdentificationInOtherEuCountriesInput } from '../../model';
import { useDispatch } from 'react-redux';
import RegistrationDetailActions from '../../../../../../redux/reducers/registration_detail_reducer/actions';

interface IActionsProps {
  rowIndex: number;
  mode: 'VIEW' | 'EDIT';
}

export default function ActionBlock(props: IActionsProps) {
  const dispatch = useDispatch();
  const deleteRow = (index: number) => {
    let reduxData = getState(ReducerKeys.REGISTRATION_DETAIL_REDUCER)
      .identificationInOtherEuCountries;
    let newData: Array<IdentificationInOtherEuCountriesInput> = new Array<IdentificationInOtherEuCountriesInput>();
    for (let i in reduxData) {
      if (Number.parseInt(i) !== index) newData.push(reduxData[i]);
    }
    dispatch(
      RegistrationDetailActions.setIdentificationInOtherEuCountriesAction(
        newData
      )
    );
  };

  return (
    <Button
      disabled={props.mode === 'VIEW'}
      onClick={() => deleteRow(props.rowIndex)}
    >
      Delete
    </Button>
  );
}
